export default "__VITE_ASSET__EhR5vmDR__"